// extracted by mini-css-extract-plugin
export var downArrow = "_ip-0";
export var infoTooltipIcon = "_ip-3";
export var label = "_ip-1";
export var optionCard = "_ip-4";
export var upArrow = "_ip-2";